import { render, staticRenderFns } from "./ShippingReportTable.vue?vue&type=template&id=47c8adb0&scoped=true"
import script from "./ShippingReportTable.vue?vue&type=script&lang=js"
export * from "./ShippingReportTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingReportTable.vue?vue&type=style&index=0&id=47c8adb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8adb0",
  null
  
)

export default component.exports